import useQueryAction from "../../../lib/useQueryAction";
import { api, makeGetRequest } from "../../api";

export interface PaginationParams {
  pageSize?: number;
  page?: number;
  name?: string;
}

export interface customerPaginationParams {
  email?: string;
  name?: string;
  search?: string;
  refereeCode?: string;
  page?: number;
  pageSize?: number;
}
export interface businessPaginationParams {
  email?: string;
  name?: string;
  refereeCode?: string;
  search?: string;
  page?: number;
  pageSize?: number;
  businessName?: string;
}
export interface RevenueParams {
  currencyType: string;
  page: number;
  pageSize: number;
  date?: string | null;
  search?: string;
}

export interface TrxParams {
  currency?: string;
  page?: number;
  pageSize?: number;
  date?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
}

export const useAccountActivities = (params?: PaginationParams) => {
  // Check if any required params are present
  const isEnabled =
    params !== undefined &&
    (params.page !== undefined ||
      params.pageSize !== undefined ||
      params.name !== undefined);

  const queryKey = ["activity", params?.page, params?.pageSize, params?.name];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.account.allAccount, params),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    enabled: isEnabled, // Now we're passing a boolean
  });
};

export const useBalance = (params?: PaginationParams) => {
  // Check if any required params are present
  const isEnabled =
    params !== undefined &&
    (params.page !== undefined ||
      params.pageSize !== undefined ||
      params.name !== undefined);

  const queryKey = ["activity", params?.page, params?.pageSize, params?.name];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.balances.index, params),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    enabled: isEnabled, // Now we're passing a boolean
  });
};
export const useIndividualCustomer = (params?: customerPaginationParams) => {
  // Check if any required params are present
  const isEnabled =
    params !== undefined &&
    (params.page !== undefined ||
      params.pageSize !== undefined ||
      params.refereeCode !== undefined ||
      params.email !== undefined ||
      params.search !== undefined ||
      params.name !== undefined);

  const queryKey = [
    "activity",
    params?.page,
    params?.pageSize,
    params?.name,
    params?.email,
    params?.search,
    params?.refereeCode,
  ];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminUsersNew, params),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    enabled: isEnabled, // Now we're passing a boolean
  });
};
export const useBusinessCustomer = (params?: businessPaginationParams) => {
  // Check if any required params are present
  const isEnabled =
    params !== undefined &&
    (params.page !== undefined ||
      params.pageSize !== undefined ||
      params.refereeCode !== undefined ||
      params.email !== undefined ||
      params.businessName !== undefined ||
      params.search !== undefined ||
      params.name !== undefined);

  const queryKey = [
    "activity",
    params?.page,
    params?.pageSize,
    params?.name,
    params?.email,
    params?.refereeCode,
    params?.search,
    params?.businessName,
  ];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminBusinessUserNew, params),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    enabled: isEnabled, // Now we're passing a boolean
  });
};

export const useTotalBalance = () => {
  const queryKey = ["activity"];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.balances.account),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    // enabled: isEnabled,
  });
};
export const useAppRevenue = (params?: RevenueParams) => {
  // Check if any required params are present
  const isEnabled =
    params !== undefined &&
    (params.page !== undefined ||
      params.pageSize !== undefined ||
      params.date !== undefined ||
      params.search !== undefined ||
      params.currencyType !== undefined);

  const queryKey = [
    "activity",
    params?.page,
    params?.pageSize,
    params?.currencyType,
    params?.date,
    params?.search,
  ];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.revenue.allRevenue, params),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    enabled: isEnabled, // Now we're passing a boolean
  });
};
export const useTransactionActivities = (params?: TrxParams) => {
  // Check if any required params are present
  const isEnabled =
    params !== undefined &&
    (params.page !== undefined ||
      params.pageSize !== undefined ||
      params.currency !== undefined ||
      params.date !== undefined ||
      params.fromDate !== undefined ||
      params.search !== undefined ||
      params.toDate !== undefined);

  // Include all filter parameters in the queryKey
  const queryKey = [
    "activity",
    params?.page,
    params?.pageSize,
    params?.date,
    params?.currency, // Add currency to queryKey
    params?.fromDate,
    params?.toDate,
    params?.search,
  ];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.transactions.allTrx, params),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    enabled: isEnabled,
  });
};
export const useAccountActivitiesCurrency = (
  currency: string,
  params?: PaginationParams
) => {
  const isEnabled =
    params !== undefined &&
    (params.page !== undefined ||
      params.pageSize !== undefined ||
      params.name !== undefined);

  const queryKey = [
    "activitybycurrency",
    params?.page,
    params?.pageSize,
    params?.name,
  ];

  return useQueryAction({
    queryFn: () => makeGetRequest(api.account.currency(currency), params),
    queryKey,
    cacheTime: 5 * 60 * 1000,
    enabled: isEnabled, // Now we're passing a boolean
  });
};
